/**
 * Hand-rolled types for `GetLevelsLifetimesQuery`. See the query file for the
 * reason these are not generated.
 */

export type LevelsLifetimeBuildingPart = {
  id: string;
  label: string;
  parent_id: string | null;
};

export type LevelsLifetimeRow = {
  id: string;
  lifetimeAverage: number | null;
  lifetimeLow: number | null;
  lifetimeHigh: number | null;
  buildingElementId: string | null;
  buildingPart: LevelsLifetimeBuildingPart | null;
};

export type LevelsLifetimeSource = {
  id: string;
  label: string;
  source: string | null;
  serviceLifetimes: LevelsLifetimeRow[];
};

export type LevelsLifetimeLookupItem = {
  id: string;
  label: string;
};

export type GetLevelsLifetimesQueryResult = {
  buildingPartLifetimeSource: LevelsLifetimeSource[];
  buildingPart: LevelsLifetimeLookupItem[];
  building_element: LevelsLifetimeLookupItem[];
};

export type GetLevelsLifetimesQueryVariables = {
  sourceId: string;
};

/**
 * Display-ready row used by the Level(s) table component.
 */
export type LevelsTableElementRow = {
  id: string;
  elementLabel: string;
  low: number | null;
  avg: number | null;
  high: number | null;
};

export type LevelsTableBuildingPartGroup = {
  id: string;
  label: string;
  rows: LevelsTableElementRow[];
};

export type LevelsTableParentGroup = {
  id: string;
  label: string;
  children: LevelsTableBuildingPartGroup[];
};

/**
 * Hasura primary key for the Level(s) (EU) lifetime source. Confirmed by
 * Mads in the RTLCA-9 issue.
 */
export const LEVELS_LIFETIME_SOURCE_ID = "76f844f0-e1aa-4ff2-a886-46983a52737b";

/**
 * Hasura primary key for the BBSR (German) lifetime source. Confirmed by
 * Mads in the RTLCA-4737 issue. The classification-code table renderer is
 * shared between the Norwegian and German sources, but the BBSR variant
 * suppresses the per-child classification code/label badges (the parent
 * group header already provides enough context).
 */
export const BBSR_LIFETIME_SOURCE_ID = "2aeaf4df-5006-44e7-bc55-0f79ab30f56d";
